import administrations from './administrations';
import operations from './operations';
import telemetry from './telemetry';
import general from './general';
import generalCRM from './generalCRM';
import apps from './apps';
import jobs from './jobs';
import video from './video';
import generalAdmin from './generalAdmin';
import generalMonitoringCenter from './generalMonitoringCenter';
import generalApiKeys from './generalApiKeys';

const sidebarOptions = [
  ...general,
  ...apps,
  ...jobs,
  ...video,
  ...operations,
  ...telemetry,
  ...administrations
];
export const sidebarOptionsCRM = [...generalCRM];
export const sidebarOptionsMonitoring = [...generalMonitoringCenter];
export const sidebarOptionsAdmin = [...generalAdmin];
export const sidebarOptionsApiKeys = [...generalApiKeys];

export function getOptions(sidebarOptions, parentTitle = null) {
  let options = [];

  sidebarOptions.forEach((option) => {
    if (option['navLink'] != null) {
      const optionNav = {
        ...option,
        isBookmarked: false,
        link: option['navLink'],

        target: option['id'],
        icon: option['iconName'],
        parentTitle: parentTitle
      };
      options.push(optionNav);
    }
    if (option['children'] != null) {
      // Pass this item's name down to its children as their parent name
      const childParentTitle = option['title'] ?? option['header'] ?? parentTitle;
      const childrenOptions = getOptions(option['children'], childParentTitle);
      options = [...options, ...childrenOptions];
    }
  });

  // Each item can show up twice: once with its section name and once without it.
  // Keep one item per id, and prefer the one that has the section name.
  const itemsById = new Map();
  options.forEach((item) => {
    const storedItem = itemsById.get(item.id);
    const storedItemHasSectionName = Boolean(storedItem?.parentTitle);

    if (!storedItem || !storedItemHasSectionName) {
      itemsById.set(item.id, item);
    }
  });

  return [...itemsById.values()];
}

export default sidebarOptions;
